import {
  MutationCache,
  QueryClient,
} from 'react-query'
import { toast } from 'react-toastify'

export const createQueryClient = (
  lastToastTime: React.MutableRefObject<number>,
) => {
  return new QueryClient({
    mutationCache: new MutationCache({
      onSuccess: () => {
        const now = Date.now()
        if (now - lastToastTime.current < 5000) {
          return
        }
        lastToastTime.current = now
        toast.success('Transaction successful')
      },
      onError: () => {
        toast.error('Transaction failed')
      },
    }),
  })
}
